import React from "react";
import moment from "moment/moment";
import { TableProperty, Tooltip } from "@shared/components";
import { PayPerLeadWithDetail } from "@shared/models/PayPerLead";
import { LeadActions } from "@containers/PayPerLead/components/PayPerLeadDashboardContainer/LeadActions/LeadActions";
import { SelectAllLeadsCheckbox, SelectLeadCheckbox } from "@containers/PayPerLead/components/SelectLeadCheckbox";
import { OverflowEllipsis } from "@shared/components/Text";

export const getLeadsTableProperties = (hasReiSiftIntegration: boolean): TableProperty<PayPerLeadWithDetail>[] => [
  {
    title: <SelectAllLeadsCheckbox />,
    key: "id",
    cellClassName: "lead-id",
    headerClassName: "lead-id",
    get: (item) => <SelectLeadCheckbox lead={item} />,
  },
  {
    title: "Name",
    key: "name",
    get: (i) => (
      <Tooltip content={i.name}>
        <OverflowEllipsis text={i.name} />
      </Tooltip>
    ),
  },
  {
    title: "Address",
    key: "address",
    cellClassName: "lead-address",
    get: (i) => {
      const addressValue = i.long_address || i.address;
      const cityValue = i.city || i.county?.name;
      const stateValue = i.state?.abbreviation || "";
      const zipValue = i.detail?.property_zip || "";

      const address = (
        <>
          {[
            addressValue,
            addressValue?.includes(cityValue) ? "" : cityValue,
            addressValue?.includes(stateValue) ? "" : stateValue,
            addressValue?.includes(zipValue) ? "" : zipValue,
          ]
            .filter((i) => i)
            .join(", ")}
        </>
      );
      return (
        <Tooltip content={address}>
          <OverflowEllipsis text={<a>{address}</a>} />
        </Tooltip>
      );
    },
  },
  {
    title: "County",
    key: "county_id",
    get: (i) => i?.county?.name,
  },
  {
    title: "Est. Value",
    key: "price",
    get: (item) =>
      item?.detail?.property_value
        ? Intl.NumberFormat("en-US", { style: "currency", currency: "USD", minimumFractionDigits: 0 }).format(
            item.detail?.property_value as number,
          )
        : "N/A",
  },
  {
    title: "Generated",
    key: "created_at",
    get: (i) => {
      const date = `${moment(i.created_at).format("lll")}`;

      return (
        <Tooltip content={date}>
          <OverflowEllipsis text={date} />
        </Tooltip>
      );
    },
  },
  {
    title: "Lead Source",
    key: "source",
    cellClassName: "lead-source",
    get: (i) => {
      const source = i.source;

      if (source) {
        return (
          <Tooltip content={source}>
            <OverflowEllipsis text={source} />
          </Tooltip>
        );
      }

      return <span>—</span>;
    },
  },
  {
    title: "",
    key: "is_qualified",
    cellClassName: "lead-status",
    headerClassName: "lead-status",
    get: (item) => <LeadActions lead={item} hasReiSiftIntegration={hasReiSiftIntegration} />,
  },
];
